export default "__VITE_ASSET__BqsLexNW__"